import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../axios';
import {Container, Form, FormBtn, FormCover, H1, H3, MediumSpacing} from "../../styles";

const StudentAdd = () => {
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [dob, setDob] = useState('');
    const navigate = useNavigate();

    const handleSubmit = (event) => {
        event.preventDefault();
        const newStudent = { first_name: firstName, last_name: lastName, dob };

        // Get the token from local storage (or wherever you store it)
        const token = localStorage.getItem('token');

        axios.post('/students/', newStudent, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
        .then(response => {
            console.log(response.data);
            navigate('/students/'); // Redirect to the students list
        })
        .catch(error => {
            console.error("There was an error creating the student!", error);
        });
    };

    return (
        <Container>
            <FormCover>
            <H3>Add Student</H3>
                <MediumSpacing/>
            <Form onSubmit={handleSubmit}>
                <div>
                    <label>First Name:</label>
                    <br/>
                    <input
                        type="text"
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                        required
                    />
                </div>
                <MediumSpacing/>
                <div>
                    <label>Last Name:</label>
                    <br/>
                    <input
                        type="text"
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                        required
                    />
                </div>
                <MediumSpacing/>
                <div>
                    <label>Date of Birth:</label>
                <br/>
                    <input
                        type="date"
                        value={dob}
                        onChange={(e) => setDob(e.target.value)}
                        required
                    />
                </div>
                <FormBtn type="submit">Add Student</FormBtn>
            </Form>
                </FormCover>
        </Container>
    );
};

export default StudentAdd;
